var $f4852a97714b8951$exports = {};
$f4852a97714b8951$exports = {
  "help": "Spikker",
  "info": "Teave"
};
export { $f4852a97714b8951$exports as default };